<template>
  <div class="product-item">
    <div>
      <el-image
        style="width: 100px; height: 100px; background: #fff"
        :src="proudctItem.image || ''"
        :fit="fitImg"
        v-if="proudctItem.image"
        @click="showViewer = true"
      />
    </div>
    <div class="product-rt">
      <div class="ellipsis item-l">{{ proudctItem.name }}</div>
      <div class="ellipsis item-l">{{ proudctItem.factory }}</div>
      <div class="ellipsis item-l">{{ proudctItem.specification }}</div>
      <div class="ellipsis item-l">{{ proudctItem.approvalNumber }}</div>
    </div>
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="[proudctItem.image]"
    />
  </div>
</template>

<script name="CbProductDom">
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
  components: { ElImageViewer },

  props: {
    proudctItem: {
      type: Object,
      default: {
        name: "",
        factory: "",
        specification: "",
        approvalNumber: "",
        image: "",
      },
    },
    fitImg: {
      type: String,
      default: "cover",
    },
  },
  data() {
    return {
      showViewer: false,
    };
  },
  methods: {
    closeViewer() {
      this.showViewer = false;
    },
  },
};
</script>
<style scoped lang="scss">
.team-apply-content {
  padding: 20px 12px;
}
.product-item {
  display: flex;
  justify-content: flex-start;
}
.product-rt {
  width: calc(100% - 100px);
  margin-left: 10px;
  div {
    text-align: left;
  }
  .item-l {
    width: 100%;
    line-height: 24px;
    margin: 0;
    display: block;
  }
}
</style>
